import {Country} from './country';
import {Carousel} from './carousel';
import {Card} from './cards';
import {Text} from './text';

export class Continent {
  id?: number = 0;
  label: string[] = [];
  countries: Country[] = [];

  constructor(value?: Continent) {
    if(value?.id != undefined) this.id = value?.id;
    this.label = value?.label ?? [];
    this.countries = value?.countries ?? [];
  }
}


export class LocationDto {
  id?: number;
  url: string;
  titleEn: string;
  titleRu: string;
  titleNatural: string;
  image: string;
  descriptionEn: string;
  descriptionRu: string;
  miniDescriptionEn?: string;
  miniDescriptionRu?: string;
  orderNumber: number;
  carousels: Carousel[];
  continent?: LocationDto;
  continentId?: number;
  country?: LocationDto;
  countryId?: number;
  city?: LocationDto;
  cityId?: number;
  file?: File;
  additionalFile?: File;
  backgroundStyle?: number;
  withoutCity?: boolean;
  withoutCountry?: boolean;
  displayPage?: boolean;
  rating?: number;
  address?: string;
  link?: string;
  runningLine?: string;
  runningLineEn?: string;
  runningLineRu?: string;
  additionalImage?: string;
  events: Events[] = [];
  additionalEvents: Events[] = [];
  cityCount?: number;
  hotelCount?: number;
  routeCount?: number;
  footerImage?: string;
  icon?: string;
  iconActive?: string;
  footerColor?: string;
  titleAccusativeRu?: string;
  cssStyleImage?: string;
  cssStyleFooterImage?: string;
  cssStyleAdditionalImage?: string;
  iconFile?: File;
  iconActiveFile?: File;
  points: Points[] = [];
  footerFile?: File;
  button: boolean = true;
  front?: boolean;
  map?: string;
  adventures: LocationDto[] = [];
  version: number = 0;
  titleBackgroundButtonText?: Text[];
  services?: boolean;
  feedValue?: Text[];
  destinationsText?: Text[];
  firstParagraph?: string[];
  objectPosition?: string;
  scale?: string;

  constructor(data?: LocationDto) {
    if(data?.id) this.id = data?.id;
    this.url = data?.url ?? "";
    this.titleEn = data?.titleEn ?? "";
    this.titleRu = data?.titleRu ?? "";
    this.titleNatural = data?.titleNatural ?? "";
    this.image = data?.image ?? "";
    this.descriptionEn = data?.descriptionEn ?? "";
    this.descriptionRu = data?.descriptionRu ?? "";
    this.miniDescriptionEn = data?.miniDescriptionEn ?? "";
    this.miniDescriptionRu = data?.miniDescriptionRu ?? "";
    this.orderNumber = data?.orderNumber ?? 0;
    this.carousels = data?.carousels ?? [];
    this.continent = data?.continent;
    this.continentId = data?.continentId ?? data?.continent?.id;
    this.country = data?.country;
    this.countryId = data?.countryId ?? data?.country?.id;
    this.city = data?.city;
    this.cityId = data?.cityId ?? data?.city?.id;
    this.file = data?.file;
    this.additionalFile = data?.additionalFile;
    this.backgroundStyle = data?.backgroundStyle;
    this.withoutCity = data?.withoutCity;
    this.withoutCountry = data?.withoutCountry;
    this.displayPage = data?.displayPage;
    this.rating = data?.rating;
    this.address = data?.address;
    this.link = data?.link;
    this.runningLine = data?.runningLine;
    this.runningLineEn = data?.runningLineEn;
    this.runningLineRu = data?.runningLineRu;
    this.additionalImage = data?.additionalImage;
    this.events = data?.events ?? [];
    this.additionalEvents = data?.additionalEvents ?? [];
    this.cityCount = data?.cityCount;
    this.hotelCount = data?.hotelCount;
    this.routeCount = data?.routeCount;
    this.footerImage = data?.footerImage;
    this.icon = data?.icon;
    this.iconActive = data?.iconActive;
    this.footerColor = data?.footerColor;
    this.titleAccusativeRu = data?.titleAccusativeRu;
    this.cssStyleImage = data?.cssStyleImage;
    this.cssStyleFooterImage = data?.cssStyleFooterImage;
    this.cssStyleAdditionalImage = data?.cssStyleAdditionalImage;
    this.iconFile = data?.iconFile;
    this.iconActiveFile = data?.iconActiveFile;
    this.points = data?.points ?? [];
    this.footerFile = data?.footerFile;
    this.button = data?.button ?? true;
    this.front = data?.front;
    this.map = data?.map;
    this.adventures = data?.adventures ?? [];
    this.version = data?.version ?? 0;
    this.titleBackgroundButtonText = data?.titleBackgroundButtonText;
    this.services = data?.services;
    this.feedValue = data?.feedValue;
    this.destinationsText = data?.destinationsText;
    this.firstParagraph = data?.firstParagraph;
    this.objectPosition = data?.objectPosition;
    this.scale= data?.scale;
  }

  getCountryLink(): string {
    const continent =  this.continent?.url;
    const country =  this.url;
    return continent && country ? `destinations/${continent}/${country}` : '';
  }
}


export class Events {
  id?: number;
  titleEn?: string = '';
  titleRu?: string = '';
  image?: string = '';
  descriptionEn?: string = '';
  descriptionRu?: string = '';
  orderNumber?: number = 0;
  cssStyle?: string;
  tag?: string;
  tagRu?: string;
  file?: File;
  toDelete?: boolean;
  version: number = 0;
  constructor(value?: Events) {
    if(value?.id != undefined) this.id = value?.id;
    this.titleEn = value?.titleEn ?? '';
    this.titleRu = value?.titleRu ?? '';
    this.image = value?.image ?? '';
    this.descriptionEn = value?.descriptionEn ?? '';
    this.descriptionRu = value?.descriptionRu ?? '';
    this.titleEn = value?.titleEn ?? '';
    this.orderNumber = value?.orderNumber ?? 0;
    this.cssStyle = value?.cssStyle ?? '';
    this.tag = value?.tag ?? '';
    this.tagRu = value?.tagRu ?? '';
    this.file = value?.file;
    this.toDelete = value?.toDelete;
    this.version = value?.version ?? 0;
  }
}

export class Points {
  id?: number;
  titleEn?: string = '';
  titleRu?: string = '';
  orderNumber?: number;
  image?: string = '';
  descriptionEn?: string = '';
  descriptionRu?: string = '';
  events: Events[] = [];
  cities?: LocationDto[];
  toDelete?: boolean;
  file?: File;
  cssStyle?: string;
  cards?: Card[];
  version: number = 0;

  constructor(value?: Points) {
    if(value?.id != undefined) this.id = value?.id;
    this.titleEn = value?.titleEn ?? '';
    this.titleRu = value?.titleRu ?? '';
    this.orderNumber = value?.orderNumber ?? 0;
    this.image = value?.image ?? '';
    this.descriptionEn = value?.descriptionEn ?? '';
    this.descriptionRu = value?.descriptionRu ?? '';
    this.events = value?.events ?? [];
    this.cities = value?.cities ?? [];
    this.toDelete = value?.toDelete;
    this.file = value?.file;
    this.cssStyle = value?.cssStyle;
    this.cards = value?.cards;
    this.version = value?.version ?? 0;
  }
}

export class VoucherDto {
  id?: number;
  clientName?: string;
  hotelName?: string;
  startDate?: string;
  endDate?: string;
  checkInTime?: string;
  checkOutTime?: string;
  hotelConfirmationNumber?: string;
  accommodation?: string;
  mealPlan?: string;
  hotelAddress?: string;
  emergency?: string;
  type?: string;
  additionalFields: AdditionalFields[] = [];
  active: boolean;
  content1?: string;
  content2?: string;
  content3?: string;
  content4?: string;
  version: number = 0;

  constructor(value?: VoucherDto) {
    if(value?.id != undefined) this.id = value?.id;
    this.clientName = value?.clientName;
    this.hotelName = value?.hotelName;
    this.startDate = value?.startDate;
    this.endDate = value?.endDate;
    this.checkInTime = value?.checkInTime;
    this.checkOutTime = value?.checkOutTime;
    this.hotelConfirmationNumber = value?.hotelConfirmationNumber;
    this.accommodation = value?.accommodation;
    this.mealPlan = value?.mealPlan;
    this.hotelAddress = value?.hotelAddress;
    this.emergency = value?.emergency;
    this.type = value?.type;
    this.additionalFields = value?.additionalFields ?? [];
    this.active = value?.active ?? true;
    this.content1 = value?.content1;
    this.content2 = value?.content2;
    this.content3 = value?.content3;
    this.content4 = value?.content4;
    this.version = value?.version ?? 0;
  }
}

export interface VoucherDisplay extends VoucherDto {
  content1: string;
  content2: string;
  content3: string;
  content4: string;
}

export class AdditionalFields {
  id?: number;
  title: string;
  value: string;
  type?: string;
  key?: string;
  orderNumber?: number;
  active: boolean = true;
  version: number = 0;
  constructor(value?: AdditionalFields) {
    if(value?.id != undefined) this.id = value?.id;
    this.title = value?.title ?? '';
    this.value = value?.value ?? '';
    this.type = value?.type;
    this.key = value?.key;
    this.orderNumber = value?.orderNumber;
    this.active = value?.active ?? true;
    this.version = value?.version ?? 0;
  }

}

export class VoucherTemplate {
  id?: number;
  name: string;
  file?: File | string;
  fields: VoucherTemplateFields[];
  active: boolean;
  version: number = 0;

  constructor(value?: VoucherTemplate) {
    if(value?.id != undefined) this.id = value?.id;
    this.name = value?.name ?? '';
    this.file = value?.file;
    this.fields = value?.fields ?? [];
    this.active = value?.active ?? true;
    this.version = value?.version ?? 0;
  }
}

export class VoucherTemplateFields {
  id?: number;
  title: string;
  type: string;
  key?: string;
  orderNumber?: number;
  active: boolean;
  version: number = 0;
  constructor(value?: VoucherTemplateFields) {
    if(value?.id != undefined) this.id = value?.id;
    this.title = value?.title ?? '';
    this.type = value?.type ?? 'STRING';
    this.key = value?.key;
    this.orderNumber = value?.orderNumber;
    this.active = value?.active ?? true;
    this.version = value?.version ?? 0;
  }
}

export class Document {
  id?: number;
  documentDate?: string;
  type: string;
  hotels: DocumentSection[] = [];
  departures: DocumentSection[] = [];
  transits: DocumentSection[] = [];
  arrivals: DocumentSection[] = [];
  transfers: DocumentSection[] = [];
  active: boolean = true;
  column?: string;
  version: number = 0;

  constructor(value: Document) {
    if(value?.id != undefined) this.id = value?.id;
    this.documentDate = value.documentDate;
    this.type = value.type ?? 'VOUCHER';
    this.hotels = value.hotels ?? [];
    this.departures = value.departures ?? [];
    this.transits = value.transits ?? [];
    this.arrivals = value.arrivals ?? [];
    this.transfers = value.transfers ?? [];
    this.active = value.active ?? true;
    this.column = value.column;
    this.version = value?.version ?? 0;
  }
}

export class DocumentSection {
  id?: number;
  guestNames?: string;
  hotelName?: string;
  accommodation?: string;
  mealPlan?: string;
  stayPeriodBegin?: string;
  stayPeriodEnd?: string;
  checkInTime?: string;
  checkOutTime?: string;
  hotelAddress?: string;
  hotelConfirmationNumber?: string;
  link?: string;
  cancellationPolicy?: string;
  flightDateTime?: string;
  flightNumber?: string;
  airportName?: string;
  guests?: string;
  serviceName?: string;
  additionalServices?: string;
  remarks?: string;
  price?: string;
  currency?: string;
  pickUp?: string;
  carAndRoute?: string;
  orderNumber?: number;
  active: boolean = true;
  version: number = 0;
  type?: 'Hotel' | 'Departure' | 'Transit' | 'Arrival' | 'Transfer';
  _deleting?: boolean;
  constructor(value: DocumentSection) {
    if(value?.id != undefined) this.id = value?.id;
    this.guestNames = value.guestNames;
    this.hotelName = value.hotelName;
    this.accommodation = value.accommodation;
    this.mealPlan = value.mealPlan;
    this.stayPeriodBegin = value.stayPeriodBegin;
    this.stayPeriodEnd = value.stayPeriodEnd;
    this.checkInTime = value.checkInTime;
    this.checkOutTime = value.checkOutTime;
    this.hotelAddress = value.hotelAddress;
    this.hotelConfirmationNumber = value.hotelConfirmationNumber;
    this.link = value.link;
    this.cancellationPolicy = value.cancellationPolicy;
    this.flightDateTime = value.flightDateTime;
    this.flightNumber = value.flightNumber;
    this.airportName = value.airportName;
    this.guests = value.guests;
    this.serviceName = value.serviceName;
    this.additionalServices = value.additionalServices;
    this.remarks = value.remarks;
    this.price = value.price;
    this.currency = value.currency;
    this.pickUp = value.pickUp;
    this.carAndRoute = value.carAndRoute;
    this.orderNumber = value.orderNumber;
    this.active = value.active ?? true;
    this.version = value?.version ?? 0;
    this.type = value?.type;
    this._deleting = value?._deleting;
  }
}

export class Currency {
  code: string = '';
  symbol: string = '';

  constructor(value: Currency) {
    this.code = value.code ?? '';
    this.symbol = value.symbol ?? '';
  }
}
